/* eslint no-unused-vars: ["error", { "args": "none" }] */
import api from '@/api';
import i18n from '@/i18n';
import utilities from '@/helpers/utilities';

const state = {
    approverType: {},
    approverTypes: [],
};

const mutations = {
    setApproverType(state, approverType) {
        state.approverType = approverType;
    },
    setApproverTypes(state, approverTypes) {
        state.approverTypes = approverTypes;
    },
};

const actions = {
    async loadApproverTypes({ commit }) {
        const response = await api.approverTypes.list();
        commit('setApproverTypes', response.data);
    },
    async fetchApproverType({ commit }, id) {
        const response = await api.approverTypes.get(id);
        commit('setApproverType', response.data);
    },
    async removeApproverType({ dispatch }, form) {
        await api.approverTypes.remove(form.id);
        await dispatch('loadApproverTypes');

        dispatch('showSuccess', i18n.t('message.success.approverTypeRemoved'));
    },
    async saveApproverType({ commit, dispatch, state }, form) {
        const response = await api.approverTypes.save(form);
        await dispatch('fetchApproverType', response.data.id);
    },
    async saveOrUpdateApproverType({ dispatch }, form) {
        if (utilities.isEmptyOrZero(form.id)) {
            await dispatch('saveApproverType', form);
        } else {
            await dispatch('updateApproverType', form);
        }

        await dispatch('loadApproverTypes');
        dispatch('showSuccess', i18n.t('message.success.saved'));
    },
    async updateApproverType({ dispatch }, form) {
        await api.approverTypes.update(form.id, form);
    },
};

const getters = {
    approverType(state) {
        return state.approverType;
    },
    approverTypes(state) {
        const approverTypes = state.approverTypes || [];
        return approverTypes
            .sort((a, b) => utilities.stringCompare(a.name, b.name))
            .filter(item => item.id !== 8);
    },
    approverTypesValueText(_, getters) {
        return getters.approverTypes.map(({ id, name, isActive }) => ({
            value: id,
            text: name,
            isActive,
        }));
    },
    approverTypesDictionary(_, getters) {
        return getters.approverTypes.reduce((map, obj) => {
            map[obj.id] = obj;
            return map;
        }, {});
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/approverTypes.js